import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LivePreviewRefreshService } from "./live-preview-refresh.service";
import {
  WidgetRefreshCoordinatorService,
  WidgetSaveRequestHandle,
} from "./widget-refresh-coordinator.service";

/** Announces successful API writes and coordinates deferred, targeted Portal
 * refresh notifications for payloads explicitly marked as widget saves. */
@Injectable()
export class ApiWriteInterceptor implements HttpInterceptor {
  constructor(
    private livePreviewRefresh: LivePreviewRefreshService,
    private widgetRefreshCoordinator: WidgetRefreshCoordinatorService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isApiWrite =
      req.method !== "GET" && req.url.startsWith(environment.baseURL);
    if (!isApiWrite) {
      return next.handle(req);
    }

    const widgetContext = this.widgetRefreshCoordinator.getMarkedWidgetContext(
      req.body,
    );
    let widgetSaveRequest: WidgetSaveRequestHandle | undefined;
    let widgetSaveSucceeded = false;

    if (widgetContext) {
      req = req.clone({
        headers: req.headers.set("X-Portal-Refresh-Mode", "deferred"),
      });
      widgetSaveRequest = this.widgetRefreshCoordinator.beginWidgetSave(
        widgetContext,
        req.headers,
      );
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          widgetSaveSucceeded = true;
          this.livePreviewRefresh.apiWrites$.next(req.url);
        }
      }),
      finalize(() => {
        if (widgetSaveRequest) {
          this.widgetRefreshCoordinator.completeWidgetSave(
            widgetSaveRequest,
            widgetSaveSucceeded,
          );
        }
      }),
    );
  }
}
